import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-select-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  templateUrl: './select-skeleton.component.html'
})
export class SelectSkeletonComponent {
  @Input() showHint: boolean = false;
}
